var map = {
	"./Positive.svg": 97277,
	"./accessibility.svg": 62207,
	"./account.svg": 21959,
	"./add-cart.svg": 27374,
	"./add.svg": 12399,
	"./alcohol-free.svg": 96729,
	"./arrow-bottom-right.svg": 92004,
	"./arrow-dropdown.svg": 92488,
	"./arrow-left.svg": 2581,
	"./arrow-right.svg": 76935,
	"./arrow-top-right.svg": 59405,
	"./assignment.svg": 89022,
	"./backspace.svg": 70214,
	"./badge.svg": 91768,
	"./bag.svg": 53177,
	"./banner-image-insert.svg": 84048,
	"./bars.svg": 19901,
	"./bold.svg": 8262,
	"./brackets-curly.svg": 15576,
	"./broadcast-arrow-line-left-white.svg": 50743,
	"./broadcast-error.svg": 31326,
	"./broadcast-pencil.svg": 37413,
	"./broadcast-warning-white.svg": 44752,
	"./bullet-list.svg": 54655,
	"./calendar-today.svg": 82758,
	"./camera.svg": 16182,
	"./campaign.svg": 62554,
	"./cards.svg": 46118,
	"./caret-bottom.svg": 96202,
	"./cart.svg": 78615,
	"./cash.svg": 59062,
	"./check-circle.svg": 89857,
	"./check.svg": 32322,
	"./chevron-bottom.svg": 80335,
	"./chevron-down.svg": 51537,
	"./chevron-left copy.svg": 92470,
	"./chevron-left.svg": 57946,
	"./chevron-right copy.svg": 3661,
	"./chevron-right.svg": 44509,
	"./chevron-top.svg": 14060,
	"./classes.svg": 37425,
	"./clock-clockwise.svg": 34215,
	"./close.svg": 4547,
	"./code.svg": 97827,
	"./copy.svg": 2516,
	"./credit-card-in.svg": 17286,
	"./credit-card-revenue-white.svg": 4816,
	"./credit-card.svg": 3497,
	"./credit_card.svg": 62781,
	"./creditcard.svg": 23418,
	"./cross.svg": 11195,
	"./customer.svg": 78009,
	"./date-range.svg": 11848,
	"./delete.svg": 55873,
	"./dismiss.svg": 19031,
	"./divider.svg": 46174,
	"./dollar.svg": 43112,
	"./double-chevron-left.svg": 80455,
	"./double-chevron-right.svg": 58312,
	"./download-simple.svg": 19114,
	"./download.svg": 62749,
	"./draft.svg": 7448,
	"./drag-handle.svg": 60516,
	"./dropdown.svg": 97198,
	"./edit-alt.svg": 41937,
	"./edit-color.svg": 31065,
	"./edit.svg": 78887,
	"./email.svg": 79231,
	"./email2.svg": 86249,
	"./envelope-simple-open-white.svg": 42125,
	"./error-circle.svg": 3161,
	"./error.svg": 28087,
	"./event.svg": 9545,
	"./export.svg": 79544,
	"./eye.svg": 58594,
	"./facebook-event.svg": 2913,
	"./facebook.svg": 23500,
	"./fb-like.svg": 9632,
	"./filter copy.svg": 2622,
	"./filter.svg": 37168,
	"./flying-mail.svg": 40586,
	"./gear.svg": 56547,
	"./google copy.svg": 35118,
	"./google.svg": 6062,
	"./graph.svg": 44082,
	"./hand-pointing-white.svg": 11791,
	"./heading-one.svg": 86810,
	"./heading-two.svg": 45773,
	"./heading.svg": 86350,
	"./help.svg": 37880,
	"./home.svg": 42333,
	"./image-placeholder.svg": 35434,
	"./image.svg": 11695,
	"./info-circle.svg": 54701,
	"./info.svg": 52173,
	"./instagram.svg": 16258,
	"./italic.svg": 39577,
	"./lightning.svg": 97184,
	"./link.svg": 47899,
	"./list.svg": 70372,
	"./live-stream.svg": 22245,
	"./location.svg": 22705,
	"./lock.svg": 23571,
	"./logout.svg": 57757,
	"./map.svg": 58784,
	"./medal.svg": 70443,
	"./megaphone.svg": 67908,
	"./member.svg": 50915,
	"./members.svg": 54322,
	"./membership.svg": 70891,
	"./menu copy.svg": 32168,
	"./menu.svg": 11228,
	"./messenger.svg": 27991,
	"./minus.svg": 95506,
	"./more-vert.svg": 79580,
	"./mountain.svg": 77630,
	"./mpaisa.svg": 41242,
	"./my-account.svg": 90346,
	"./my-tickets.svg": 38838,
	"./negative.svg": 15838,
	"./no-data-illustration.svg": 51441,
	"./notify.svg": 9556,
	"./number-list.svg": 24549,
	"./ol.svg": 25528,
	"./orders.svg": 66832,
	"./overview.svg": 97877,
	"./palette.svg": 36769,
	"./paper-plane-right.svg": 96459,
	"./pencil-outlined.svg": 31825,
	"./pencil.svg": 19376,
	"./perm_contact_calendar.svg": 41269,
	"./play.svg": 47080,
	"./plus.svg": 36509,
	"./price-tag.svg": 95662,
	"./print.svg": 29478,
	"./priority-high.svg": 8843,
	"./prohibit.svg": 67868,
	"./puzzle.svg": 77210,
	"./radio-checked.svg": 6951,
	"./radio.svg": 52817,
	"./redeem.svg": 54667,
	"./remove-circle.svg": 93920,
	"./remove.svg": 66661,
	"./reports.svg": 5997,
	"./rich-text-button.svg": 78095,
	"./robot.svg": 51199,
	"./schedule.svg": 20612,
	"./search copy.svg": 20165,
	"./search.svg": 32218,
	"./settings.svg": 47985,
	"./settings_applications.svg": 59000,
	"./share.svg": 94532,
	"./shipping.svg": 40844,
	"./shopping-cart.svg": 80054,
	"./star.svg": 26347,
	"./studio.svg": 28644,
	"./support.svg": 95583,
	"./teachers.svg": 53674,
	"./text-align-center.svg": 79728,
	"./text-align-left.svg": 45513,
	"./text-align-right.svg": 16444,
	"./text-insert.svg": 22610,
	"./ticket-white.svg": 40736,
	"./tiktok.svg": 20124,
	"./time-alt.svg": 43968,
	"./time.svg": 10533,
	"./trash-new.svg": 12442,
	"./trash.svg": 70253,
	"./trending_up.svg": 29465,
	"./twitter-email.svg": 52143,
	"./twitter.svg": 29321,
	"./ul.svg": 94839,
	"./upload.svg": 43467,
	"./user-account.svg": 41950,
	"./user-square.svg": 50556,
	"./user.svg": 76077,
	"./users.svg": 32658,
	"./video-camera.svg": 40575,
	"./warning-circle.svg": 81226,
	"./warning-triangle-unfilled.svg": 59313,
	"./warning.svg": 97752,
	"./workshops.svg": 93107,
	"./zoom-in.svg": 90909,
	"./zoom-out.svg": 80270,
	"src/components/common/Icon/library/Positive.svg": 97277,
	"src/components/common/Icon/library/accessibility.svg": 62207,
	"src/components/common/Icon/library/account.svg": 21959,
	"src/components/common/Icon/library/add-cart.svg": 27374,
	"src/components/common/Icon/library/add.svg": 12399,
	"src/components/common/Icon/library/alcohol-free.svg": 96729,
	"src/components/common/Icon/library/arrow-bottom-right.svg": 92004,
	"src/components/common/Icon/library/arrow-dropdown.svg": 92488,
	"src/components/common/Icon/library/arrow-left.svg": 2581,
	"src/components/common/Icon/library/arrow-right.svg": 76935,
	"src/components/common/Icon/library/arrow-top-right.svg": 59405,
	"src/components/common/Icon/library/assignment.svg": 89022,
	"src/components/common/Icon/library/backspace.svg": 70214,
	"src/components/common/Icon/library/badge.svg": 91768,
	"src/components/common/Icon/library/bag.svg": 53177,
	"src/components/common/Icon/library/banner-image-insert.svg": 84048,
	"src/components/common/Icon/library/bars.svg": 19901,
	"src/components/common/Icon/library/bold.svg": 8262,
	"src/components/common/Icon/library/brackets-curly.svg": 15576,
	"src/components/common/Icon/library/broadcast-arrow-line-left-white.svg": 50743,
	"src/components/common/Icon/library/broadcast-error.svg": 31326,
	"src/components/common/Icon/library/broadcast-pencil.svg": 37413,
	"src/components/common/Icon/library/broadcast-warning-white.svg": 44752,
	"src/components/common/Icon/library/bullet-list.svg": 54655,
	"src/components/common/Icon/library/calendar-today.svg": 82758,
	"src/components/common/Icon/library/camera.svg": 16182,
	"src/components/common/Icon/library/campaign.svg": 62554,
	"src/components/common/Icon/library/cards.svg": 46118,
	"src/components/common/Icon/library/caret-bottom.svg": 96202,
	"src/components/common/Icon/library/cart.svg": 78615,
	"src/components/common/Icon/library/cash.svg": 59062,
	"src/components/common/Icon/library/check-circle.svg": 89857,
	"src/components/common/Icon/library/check.svg": 32322,
	"src/components/common/Icon/library/chevron-bottom.svg": 80335,
	"src/components/common/Icon/library/chevron-down.svg": 51537,
	"src/components/common/Icon/library/chevron-left copy.svg": 92470,
	"src/components/common/Icon/library/chevron-left.svg": 57946,
	"src/components/common/Icon/library/chevron-right copy.svg": 3661,
	"src/components/common/Icon/library/chevron-right.svg": 44509,
	"src/components/common/Icon/library/chevron-top.svg": 14060,
	"src/components/common/Icon/library/classes.svg": 37425,
	"src/components/common/Icon/library/clock-clockwise.svg": 34215,
	"src/components/common/Icon/library/close.svg": 4547,
	"src/components/common/Icon/library/code.svg": 97827,
	"src/components/common/Icon/library/copy.svg": 2516,
	"src/components/common/Icon/library/credit-card-in.svg": 17286,
	"src/components/common/Icon/library/credit-card-revenue-white.svg": 4816,
	"src/components/common/Icon/library/credit-card.svg": 3497,
	"src/components/common/Icon/library/credit_card.svg": 62781,
	"src/components/common/Icon/library/creditcard.svg": 23418,
	"src/components/common/Icon/library/cross.svg": 11195,
	"src/components/common/Icon/library/customer.svg": 78009,
	"src/components/common/Icon/library/date-range.svg": 11848,
	"src/components/common/Icon/library/delete.svg": 55873,
	"src/components/common/Icon/library/dismiss.svg": 19031,
	"src/components/common/Icon/library/divider.svg": 46174,
	"src/components/common/Icon/library/dollar.svg": 43112,
	"src/components/common/Icon/library/double-chevron-left.svg": 80455,
	"src/components/common/Icon/library/double-chevron-right.svg": 58312,
	"src/components/common/Icon/library/download-simple.svg": 19114,
	"src/components/common/Icon/library/download.svg": 62749,
	"src/components/common/Icon/library/draft.svg": 7448,
	"src/components/common/Icon/library/drag-handle.svg": 60516,
	"src/components/common/Icon/library/dropdown.svg": 97198,
	"src/components/common/Icon/library/edit-alt.svg": 41937,
	"src/components/common/Icon/library/edit-color.svg": 31065,
	"src/components/common/Icon/library/edit.svg": 78887,
	"src/components/common/Icon/library/email.svg": 79231,
	"src/components/common/Icon/library/email2.svg": 86249,
	"src/components/common/Icon/library/envelope-simple-open-white.svg": 42125,
	"src/components/common/Icon/library/error-circle.svg": 3161,
	"src/components/common/Icon/library/error.svg": 28087,
	"src/components/common/Icon/library/event.svg": 9545,
	"src/components/common/Icon/library/export.svg": 79544,
	"src/components/common/Icon/library/eye.svg": 58594,
	"src/components/common/Icon/library/facebook-event.svg": 2913,
	"src/components/common/Icon/library/facebook.svg": 23500,
	"src/components/common/Icon/library/fb-like.svg": 9632,
	"src/components/common/Icon/library/filter copy.svg": 2622,
	"src/components/common/Icon/library/filter.svg": 37168,
	"src/components/common/Icon/library/flying-mail.svg": 40586,
	"src/components/common/Icon/library/gear.svg": 56547,
	"src/components/common/Icon/library/google copy.svg": 35118,
	"src/components/common/Icon/library/google.svg": 6062,
	"src/components/common/Icon/library/graph.svg": 44082,
	"src/components/common/Icon/library/hand-pointing-white.svg": 11791,
	"src/components/common/Icon/library/heading-one.svg": 86810,
	"src/components/common/Icon/library/heading-two.svg": 45773,
	"src/components/common/Icon/library/heading.svg": 86350,
	"src/components/common/Icon/library/help.svg": 37880,
	"src/components/common/Icon/library/home.svg": 42333,
	"src/components/common/Icon/library/image-placeholder.svg": 35434,
	"src/components/common/Icon/library/image.svg": 11695,
	"src/components/common/Icon/library/info-circle.svg": 54701,
	"src/components/common/Icon/library/info.svg": 52173,
	"src/components/common/Icon/library/instagram.svg": 16258,
	"src/components/common/Icon/library/italic.svg": 39577,
	"src/components/common/Icon/library/lightning.svg": 97184,
	"src/components/common/Icon/library/link.svg": 47899,
	"src/components/common/Icon/library/list.svg": 70372,
	"src/components/common/Icon/library/live-stream.svg": 22245,
	"src/components/common/Icon/library/location.svg": 22705,
	"src/components/common/Icon/library/lock.svg": 23571,
	"src/components/common/Icon/library/logout.svg": 57757,
	"src/components/common/Icon/library/map.svg": 58784,
	"src/components/common/Icon/library/medal.svg": 70443,
	"src/components/common/Icon/library/megaphone.svg": 67908,
	"src/components/common/Icon/library/member.svg": 50915,
	"src/components/common/Icon/library/members.svg": 54322,
	"src/components/common/Icon/library/membership.svg": 70891,
	"src/components/common/Icon/library/menu copy.svg": 32168,
	"src/components/common/Icon/library/menu.svg": 11228,
	"src/components/common/Icon/library/messenger.svg": 27991,
	"src/components/common/Icon/library/minus.svg": 95506,
	"src/components/common/Icon/library/more-vert.svg": 79580,
	"src/components/common/Icon/library/mountain.svg": 77630,
	"src/components/common/Icon/library/mpaisa.svg": 41242,
	"src/components/common/Icon/library/my-account.svg": 90346,
	"src/components/common/Icon/library/my-tickets.svg": 38838,
	"src/components/common/Icon/library/negative.svg": 15838,
	"src/components/common/Icon/library/no-data-illustration.svg": 51441,
	"src/components/common/Icon/library/notify.svg": 9556,
	"src/components/common/Icon/library/number-list.svg": 24549,
	"src/components/common/Icon/library/ol.svg": 25528,
	"src/components/common/Icon/library/orders.svg": 66832,
	"src/components/common/Icon/library/overview.svg": 97877,
	"src/components/common/Icon/library/palette.svg": 36769,
	"src/components/common/Icon/library/paper-plane-right.svg": 96459,
	"src/components/common/Icon/library/pencil-outlined.svg": 31825,
	"src/components/common/Icon/library/pencil.svg": 19376,
	"src/components/common/Icon/library/perm_contact_calendar.svg": 41269,
	"src/components/common/Icon/library/play.svg": 47080,
	"src/components/common/Icon/library/plus.svg": 36509,
	"src/components/common/Icon/library/price-tag.svg": 95662,
	"src/components/common/Icon/library/print.svg": 29478,
	"src/components/common/Icon/library/priority-high.svg": 8843,
	"src/components/common/Icon/library/prohibit.svg": 67868,
	"src/components/common/Icon/library/puzzle.svg": 77210,
	"src/components/common/Icon/library/radio-checked.svg": 6951,
	"src/components/common/Icon/library/radio.svg": 52817,
	"src/components/common/Icon/library/redeem.svg": 54667,
	"src/components/common/Icon/library/remove-circle.svg": 93920,
	"src/components/common/Icon/library/remove.svg": 66661,
	"src/components/common/Icon/library/reports.svg": 5997,
	"src/components/common/Icon/library/rich-text-button.svg": 78095,
	"src/components/common/Icon/library/robot.svg": 51199,
	"src/components/common/Icon/library/schedule.svg": 20612,
	"src/components/common/Icon/library/search copy.svg": 20165,
	"src/components/common/Icon/library/search.svg": 32218,
	"src/components/common/Icon/library/settings.svg": 47985,
	"src/components/common/Icon/library/settings_applications.svg": 59000,
	"src/components/common/Icon/library/share.svg": 94532,
	"src/components/common/Icon/library/shipping.svg": 40844,
	"src/components/common/Icon/library/shopping-cart.svg": 80054,
	"src/components/common/Icon/library/star.svg": 26347,
	"src/components/common/Icon/library/studio.svg": 28644,
	"src/components/common/Icon/library/support.svg": 95583,
	"src/components/common/Icon/library/teachers.svg": 53674,
	"src/components/common/Icon/library/text-align-center.svg": 79728,
	"src/components/common/Icon/library/text-align-left.svg": 45513,
	"src/components/common/Icon/library/text-align-right.svg": 16444,
	"src/components/common/Icon/library/text-insert.svg": 22610,
	"src/components/common/Icon/library/ticket-white.svg": 40736,
	"src/components/common/Icon/library/tiktok.svg": 20124,
	"src/components/common/Icon/library/time-alt.svg": 43968,
	"src/components/common/Icon/library/time.svg": 10533,
	"src/components/common/Icon/library/trash-new.svg": 12442,
	"src/components/common/Icon/library/trash.svg": 70253,
	"src/components/common/Icon/library/trending_up.svg": 29465,
	"src/components/common/Icon/library/twitter-email.svg": 52143,
	"src/components/common/Icon/library/twitter.svg": 29321,
	"src/components/common/Icon/library/ul.svg": 94839,
	"src/components/common/Icon/library/upload.svg": 43467,
	"src/components/common/Icon/library/user-account.svg": 41950,
	"src/components/common/Icon/library/user-square.svg": 50556,
	"src/components/common/Icon/library/user.svg": 76077,
	"src/components/common/Icon/library/users.svg": 32658,
	"src/components/common/Icon/library/video-camera.svg": 40575,
	"src/components/common/Icon/library/warning-circle.svg": 81226,
	"src/components/common/Icon/library/warning-triangle-unfilled.svg": 59313,
	"src/components/common/Icon/library/warning.svg": 97752,
	"src/components/common/Icon/library/workshops.svg": 93107,
	"src/components/common/Icon/library/zoom-in.svg": 90909,
	"src/components/common/Icon/library/zoom-out.svg": 80270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29381;